// components/FileUpload.jsx
import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { setFile } from '../../../Store/reshootFiles'; // Update path if needed
import { useNavigate } from "react-router-dom";

const FileUpload = () => {
    const dispatch = useDispatch();
    const previews = useSelector((state) => state.reshootFiles?.previews || {});
    const navigate = useNavigate()


    const validationSchema = Yup.object().shape({
        aadhaarFront: Yup.mixed(),
        aadhaarBack: Yup.mixed(),
        panCard: Yup.mixed().required('PAN Card front is required'),
    }).test(
        'aadhaarCheck',
        'Either Aadhaar Front or Aadhaar Back must be uploaded',
        function (values) {
            return !!values.aadhaarFront || !!values.aadhaarBack;
        }
    );

    const formik = useFormik({
        initialValues: {
            aadhaarFront: null,
            aadhaarBack: null,
            panCard: null,
        },
        validationSchema,
        validateOnMount: false,
        validateOnBlur: true,
        validateOnChange: false,
        onSubmit: (values) => {
            const formData = new FormData();
            if (values.aadhaarFront) formData.append('aadhaarFront', values.aadhaarFront);
            if (values.aadhaarBack) formData.append('aadhaarBack', values.aadhaarBack);
            if (values.panCard) formData.append('panCard', values.panCard);
            const company = localStorage.getItem("company")
            const cameraside = localStorage.getItem("cameraSide")
            const uid = localStorage.getItem("uid")
            navigate(`/review/${uid}/${company}/${cameraside}/review-scan`)
        },
    });

    const handleFileChange = (e, fieldName) => {
        const file = e.currentTarget.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                dispatch(setFile({ field: fieldName, file, preview: reader.result }));
            };
            reader.readAsDataURL(file);
            formik.setFieldValue(fieldName, file);
        }
    };

    return (
        <div style={styles.container}>
            <h2 style={styles.heading}>Upload Identity Documents</h2>
            <p style={styles.instruction}>Upload clear Aadhaar (front/back) and PAN card (front).</p>

            <form onSubmit={formik.handleSubmit} style={styles.form}>
                <label style={styles.label}>Aadhaar Front (optional)</label>
                <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleFileChange(e, 'aadhaarFront')}
                    style={styles.input}
                />
                {previews.aadhaarFront && (
                    <img src={previews.aadhaarFront} alt="Aadhaar Front" style={styles.preview} />
                )}

                <label style={styles.label}>Aadhaar Back (optional)</label>
                <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleFileChange(e, 'aadhaarBack')}
                    style={styles.input}
                />
                {previews.aadhaarBack && (
                    <img src={previews.aadhaarBack} alt="Aadhaar Back" style={styles.preview} />
                )}

                <label style={styles.label}>PAN Card Front (required)</label>
                <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleFileChange(e, 'panCard')}
                    style={styles.input}
                />
                {previews.panCard && (
                    <img src={previews.panCard} alt="PAN Card" style={styles.preview} />
                )}

                {formik.errors.panCard && formik.touched.panCard && (
                    <p style={styles.error}>{formik.errors.panCard}</p>
                )}
                {formik.errors.aadhaarCheck && (
                    <p style={styles.error}>{formik.errors.aadhaarCheck}</p>
                )}

                <button type="submit" style={styles.button}>Submit</button>
            </form>
        </div>
    );
};

const styles = {
    container: {
        padding: 20,
        maxWidth: 400,
        margin: 'auto',
        fontFamily: 'sans-serif',
        color: '#000',
    },
    heading: {
        fontSize: 20,
        fontWeight: 'bold',
        marginBottom: 10,
        textAlign: 'center',
    },
    instruction: {
        fontSize: 14,
        color: '#333',
        marginBottom: 20,
        textAlign: 'center',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
    },
    label: {
        fontWeight: 'bold',
        marginTop: 10,
    },
    input: {
        marginBottom: 10,
    },
    preview: {
        width: '100%',
        height: 'auto',
        marginBottom: 10,
        border: '1px solid #ccc',
        borderRadius: 6,
    },
    error: {
        color: 'red',
        fontSize: 12,
    },
    button: {
        backgroundColor: '#000',
        color: '#fff',
        padding: 12,
        fontWeight: 'bold',
        border: 'none',
        borderRadius: 6,
        marginTop: 20,
    },
};

export default FileUpload;
